import {
  GetFileDownloadUrlCommand,
  GetFileDownloadUrlCommandOutput,
  GetFileDownloadUrlCommandInput,
} from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticatedClient } from "../setup/getAuthenticatedClient";
import { MetricsPublisher } from "../../metrics/metrics";

export async function getFileService(input: GetFileDownloadUrlCommandInput) {
  const { client } = await getAuthenticatedClient();
  if (!client) {
    return Promise.reject(new Error("Unauthorized"));
  }
  const command = new GetFileDownloadUrlCommand(input);
  const metricsPublisher = new MetricsPublisher("api.getFile");

  return await client
    .send(command)
    .then((response: GetFileDownloadUrlCommandOutput) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return response;
    })
    .catch((error: any) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
